import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao } from 'px-business-components';

const hasCamposErpSankhya = camposIntegracao => camposIntegracao.natureza !== null;

const hasCamposErpSankhyaNorsil = (camposIntegracao, isCarrinho) => {
  if (isCarrinho) {
    return (camposIntegracao.natureza !== null && camposIntegracao.operacao !== null)
    || camposIntegracao.natureza !== null;
  }
  return camposIntegracao.natureza !== null && camposIntegracao.operacao !== null;
};

const hasCamposErpSankhyaArtLatex = camposIntegracao => camposIntegracao.natureza !== null
  && camposIntegracao.operacao !== null;

const hasCamposErpTotvs = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpTotvsProtheus = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpM365BuscheLepper = camposIntegracao => camposIntegracao
  .condicaoPagamento !== null;

const hasCamposErpSenior = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpCigam = camposIntegracao => camposIntegracao.condicaoPagamento !== null
  && camposIntegracao.contaFinanceira !== null;

const hasCamposErpSapB1 = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpSeniorTeixeira = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpSeniorMedal = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpLm = camposIntegracao => camposIntegracao.tipoCobranca !== null;

const hasCamposErpUseall = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpUseallSetup = camposIntegracao => camposIntegracao.condicaoPagamento !== null
  && camposIntegracao.observacaoInterna !== null;

const hasCamposErpNeoGabriella = camposIntegracao => camposIntegracao.tipoCompra !== null;

export const hasCadastrosAdicionaisErp = (tipoErp, camposIntegracao, isCarrinho) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return hasCamposErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return hasCamposErpM365BuscheLepper(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return hasCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return hasCamposErpSankhyaNorsil(camposIntegracao, isCarrinho);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return hasCamposErpSankhyaArtLatex(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return hasCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return hasCamposErpCigam(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return hasCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return hasCamposErpSeniorMedal(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return hasCamposErpLm(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key) {
    return hasCamposErpUseall(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return hasCamposErpUseallSetup(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return hasCamposErpNeoGabriella(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return hasCamposErpSapB1(camposIntegracao);
  }
  return false;
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpTotvsProtheus = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpM365BuscheLepper = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpCigam = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  if (!camposIntegracao.contaFinanceira) {
    return [false, 'Conta é obrigatória'];
  }

  return [true, null];
};

const validateCamposErpSapB1 = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorTeixeira = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorMedal = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpLm = (camposIntegracao) => {
  if (!camposIntegracao.tipoCobranca) {
    return [false, 'O tipo de cobrança é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpUseall = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpUseallSetup = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  if (!camposIntegracao.observacaoInterna) {
    return [false, 'Observação interna é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSankhya = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSankhyaNorsil = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  if (!camposIntegracao.operacao) {
    return [false, 'Tipo de operação é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSankhyaArtLatex = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  if (!camposIntegracao.operacao) {
    return [false, 'Tipo de operação é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpNeoGabriella = (camposIntegracao) => {
  if (!camposIntegracao.tipoCompra) {
    return [false, 'O tipo de compra é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpSeniorPfiffner = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return validateCamposErpTotvsProtheus(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return validateCamposErpM365BuscheLepper(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return validateCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return validateCamposErpSankhyaNorsil(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return validateCamposErpSankhyaArtLatex(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return validateCamposErpCigam(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return validateCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return validateCamposErpSeniorMedal(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return validateCamposErpLm(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key) {
    return validateCamposErpUseall(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return validateCamposErpUseallSetup(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return validateCamposErpNeoGabriella(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return validateCamposErpSapB1(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return validateCamposErpSeniorPfiffner(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
      operacao: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.OPERACAO.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
      operacao: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.OPERACAO.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
      contaFinanceira: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return {
      tipoCobranca: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.TIPO_COBRANCA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key
  ) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
      observacaoInterna: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.OBSERVACAO_INTERNA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      tipoCompra: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.TIPO_COMPRA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      natureza: null,
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS_PROTHEUS.key) {
    return {
      natureza: null,
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.M365_BUSCHE_LEPPER.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return {
      natureza: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      natureza: null,
      operacao: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      natureza: null,
      operacao: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.CIGAM.key) {
    return {
      condicaoPagamento: null,
      contaFinanceira: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_MEDAL.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return {
      tipoCobranca: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key
  ) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return {
      condicaoPagamento: null,
      observacaoInterna: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      tipoCompra: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.FOCCO.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SAP_B1.key) {
    return {
      condicaoPagamento: null,
    };
  }
  return {};
};
